export default function Excel_Tables() {
  return <div>Excel_Tables</div>;
}
